import { Injectable ,Output, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecimalPipe, DatePipe } from '@angular/common';
import { Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService } from '../../../Core/Security/security.service';
import { ConfigService } from '../../../Core/Abstract/config.service';
import { LogService } from '../../../Core/Abstract/log.service';

import { EventsEmitterService } from '../../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';
import * as moment from 'moment/moment';
import { GridService } from 'app/Core/Abstract/grid.service';

@Injectable()

export class ContactUsService extends SecurityService{
    @Output() change: EventEmitter<boolean> = new EventEmitter();
    constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService, private datePipe:DatePipe) {
        super(http,configService,eventsEmitterService, router ,logger);
    }

    submitContactForm(contact): Observable<any>{
        let serviceUrl = this.baseUrl + 'ContactService/contactForm';
        return this.http.post<any>(serviceUrl,contact).pipe(map(response => {return response;}));
    }
    public getCountryCodesList(langId: string): Observable<any> {
    let serviceUrl = this.baseUrl + "UtilService/getCountryMobileCodes?langId=" + langId;
    
    return this.http.get(serviceUrl).pipe(map(super.extractData),catchError(super.handleError));}
}
